// Define multiple environments
export const CONFIG = {
  qa: {
    BASE_PATH: '/EnhancedUI',
    ASSET_PREFIX: '/EnhancedUI/',
    API_URL: 'https://qa-api.shahen-sa.com',
  },
  prod: {
    BASE_PATH: '',
    ASSET_PREFIX: '',
    API_URL: 'https://api.shahen-sa.com',
  },
};

// Default environment (fallback)
export const ENV = process.env.NEXT_PUBLIC_ENV || 'prod';
